export const BRAND_PADDINGS = {
  SIZE_10: '--brand-paddings-size-10',
} as const
export type BRAND_PADDINGS =
  (typeof BRAND_PADDINGS)[keyof typeof BRAND_PADDINGS]
